import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { List as ListComponent, useDrawer, DrawerButton, SplitButton } from 'src/mtska-frontend-app-component';
import { useGridApiRef } from '@mui/x-data-grid';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import ImportButton from '../../Import/components/ImportButton';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadAll } from 'src/mtska-frontend-data-provider/hooks/useLoadAll.hooks';

const dataProviderName = 'zoho/manageableorder';
const drawerRouteBase = 'ordermanagement';

const moduleName = "Zoho Orders";

const List = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);
    const { activate } = useDrawer();

    const apiRef = useGridApiRef();
    const getSelected = () => {
        return [...apiRef.current.getSelectedRows()].map(([name]) => name);
    };
    const [selected, setSelected] = useState([]);
    const handleRowSelection = (newSelection) => {
        setSelected(newSelection);
        params.rowSelectionExternalListener && params.rowSelectionExternalListener(newSelection);
    };

    const { doAction, loadAll, items, total, loading, reloadCounter } = useDataProvider(dataProviderName);
    const [listFilterPageSort, setListFilterPageSort] = useState();
    const handleFilterPageSortChange = (model) => {
        setListFilterPageSort(model);
    }

    useLoadAll({ listFilterPageSort, loadAll, params, reloadCounter })

    const handleRowDoubleclick = (row) => {
        if (row.id.includes('_')) return;
        activate(drawerRouteBase + '/detail', { id: row.id });
    }


    return (
        <>
            {userCapabilities && userCapabilities[dataProviderName + '.list'] && (
                <>
                    <ListComponent
                        {...params}
                        onRowDoubleClick={(userCapabilities && userCapabilities[dataProviderName + '.view']) ? handleRowDoubleclick : () => { }}
                        onFilterPageSortChange={handleFilterPageSortChange}
                        items={items}
                        total={total}
                        loading={loading}
                        apiRef={apiRef}
                        enableSelection
                        selected={selected}
                        rightButtons={[
                            <SplitButton
                                selectedItems={selected}
                                actions={[
                                    {
                                        disabled: (userCapabilities && !userCapabilities[dataProviderName + '.create']),
                                        icon: "faCog",
                                        label: t('Apply action'),
                                        onClick: () => {
                                            activate(
                                                drawerRouteBase + '/applyAction',
                                                {
                                                    items: selected,
                                                    dataProviderName: dataProviderName,
                                                    onActionDone: () => {
                                                        setSelected([]);
                                                    }
                                                },
                                            )
                                        }
                                    },
                                    
                                    {
                                        disabled: userCapabilities && !userCapabilities[dataProviderName + '.export'],
                                        disabledIfNoItemselected: false,
                                        icon: "faDownload",
                                        label: t('Export'),
                                        onClick: () => {
                                            activate(
                                                'wizards/download',
                                                {
                                                    dataProviderName: dataProviderName,
                                                    recipe: 'recipes.zoho.order',
                                                    recipes: {
                                                        'recipes.zoho.order': 'Zoho Order',
                                                    }
                                                },
                                            )
                                        }
                                    },
                                    
                                ]}
                            />,

                        ]}
                        dataProviderName={dataProviderName}
                        title={moduleName}
                        rowSelectionExternalListener={handleRowSelection}
                        doAction={doAction}
                        treeData
                        treeDataDrawerRoutes={{'inspect':'cars/detail', 'choose':'ordermanagement/detail', 'contract': 'contracts/detail'}}
                    />
                </>
            )}
        </>
    );
};

export default List;


